import dance from "./dance.jsx";
import chat from "./chat.jsx";
import greeting from "./greeting.jsx";
import face from "./face.jsx";
import interact from "./interact.jsx";
import move from "./move.jsx";
import patrol from "./patrol.jsx";
import script from "./script.jsx";
import dialogue from "./dialogue.jsx";
import changezone from "./changezone.jsx";
import animate from "./animate.jsx";

export default {
  dance,
  chat,
  greeting,
  face,
  interact,
  move,
  patrol,
  script,
  dialogue,
  animate,
  changezone,
};
